import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ExtensionInstallStatsCard } from '@apps/web/components/home/extension_install_stats_card';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/chrome-extension')({
    component: ChromeExtensionPage,
});

function ChromeExtensionPage() {
    const { gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }

    return (
        <SettingsPageShell
            title="Chrome Extension"
            description="Share the install link and track team setup."
        >
            <ExtensionInstallStatsCard />
        </SettingsPageShell>
    );
}
